import React from 'react';
import {
  Box,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  Typography,
  Button,
  IconButton,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

// Constants for dropdown options
const GENDERS = [
  { value: '', label: '-' },
  { value: 'male', label: 'Laki-laki' },
  { value: 'female', label: 'Perempuan' },
];

const MARITALS = [
  { value: '', label: '-' },
  { value: 'single', label: 'Lajang' },
  { value: 'married', label: 'Nikah' },
  { value: 'divorce', label: 'Cerai' },
];

const BLOODS = ['', 'A', 'B', 'AB', 'O'];

const RELIGIONS = [
  { value: '', label: '-' },
  { value: 'Islam', label: 'Islam' },
  { value: 'Kristen', label: 'Kristen' },
  { value: 'Katolik', label: 'Katolik' },
  { value: 'Hindu', label: 'Hindu' },
  { value: 'Buddha', label: 'Buddha' },
  { value: 'Konghucu', label: 'Konghucu' },
];

const LIVING_ARRANGEMENTS = [
  { value: '', label: '-' },
  { value: 'Private', label: 'Rumah Sendiri' },
  { value: 'Parents', label: 'Bersama Orang Tua' },
  { value: 'Rental', label: 'Kontrakan/Kost' },
  { value: 'Boarding', label: 'Mess' },
];

const EDUCATION_LEVELS = [
  { value: '', label: '-' },
  { value: 'TK', label: 'TK' },
  { value: 'SD', label: 'SD' },
  { value: 'SMP', label: 'SMP' },
  { value: 'SMA', label: 'SMA' },
  { value: 'D1', label: 'D1' },
  { value: 'D3', label: 'D3' },
  { value: 'S1', label: 'S1' },
  { value: 'S2', label: 'S2' },
  { value: 'S3', label: 'S3' },
];

// Komponen reusable untuk setiap anggota keluarga
const FamilyMember = ({ 
  index, 
  title, 
  form, 
  handleChange, 
  onRemove,
  showRemove = false,
  isSibling = false,
  isChild = false
}) => {
  // Tentukan data source berdasarkan tipe
  let dataSource;
  let namePrefix;
  
  if (isSibling) {
    dataSource = form.siblings || [];
    namePrefix = 'siblings';
  } else if (isChild) {
    dataSource = form.children || [];
    namePrefix = 'children';
  } else {
    dataSource = form.familyData || [];
    namePrefix = 'familyData';
  }
  
  const data = dataSource[index] || {};
  
  return (
  <Box sx={{ mb: 3, p: 2, backgroundColor: '#fff', borderRadius: 1, border: '1px solid #e0e0e0' }}>
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#555' }}>
        {title}
      </Typography>
      {showRemove && (
        <IconButton 
          onClick={onRemove}
          size="small"
          sx={{ color: '#d32f2f' }}
        >
          <RemoveIcon />
        </IconButton>
      )}
    </Box>
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <TextField 
          label="Usia" 
          name={`${namePrefix}.${index}.age`} 
          value={data.age || ''} 
          onChange={handleChange} 
          fullWidth 
          size="small"
          placeholder="Contoh: 25"
          variant="outlined"
          type="number"
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ddd',
              },
              '&:hover fieldset': {
                borderColor: '#1976d2',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976d2',
              },
            },
            '& .MuiInputLabel-root': {
              fontWeight: 500,
              color: '#555',
            },
          }}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel>Pendidikan</InputLabel>
          <Select 
            name={`${namePrefix}.${index}.education`} 
            value={data.education || ''} 
            onChange={handleChange} 
            label="Pendidikan"
            sx={{
              minWidth: 200,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#ddd',
                },
                '&:hover fieldset': {
                  borderColor: '#1976d2',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#1976d2',
                },
              },
              '& .MuiInputLabel-root': {
                fontWeight: 500,
                color: '#555',
              },
            }}
          >
            {EDUCATION_LEVELS.map((level) => (
              <MenuItem key={level.value} value={level.value}>
                {level.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField 
          label="Pekerjaan" 
          name={`${namePrefix}.${index}.job`} 
          value={data.job || ''} 
          onChange={handleChange} 
          fullWidth 
          size="small"
          placeholder="Contoh: Swasta"
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ddd',
              },
              '&:hover fieldset': {
                borderColor: '#1976d2',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976d2',
              },
            },
            '& .MuiInputLabel-root': {
              fontWeight: 500,
              color: '#555',
            },
          }}
        />
      </Grid>
    </Grid>
  </Box>
  );
};

const Step1DataPribadi = ({ form, setForm, addSibling, removeSibling, addChild, removeChild }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log('Step1 handleChange called:', { name, value });
    
    // Handle nested object paths like "familyData.0.relation"
    if (name.includes('.')) {
      const [parent, index, field] = name.split('.');
      const arrayIndex = parseInt(index, 10);
      
      setForm(prev => {
        const newForm = { ...prev };
        if (!newForm[parent]) {
          newForm[parent] = [];
        }
        if (!newForm[parent][arrayIndex]) {
          newForm[parent][arrayIndex] = {};
        }
        newForm[parent][arrayIndex] = {
          ...newForm[parent][arrayIndex],
          [field]: value
        };
        console.log('Step1 updated form (nested):', newForm);
        return newForm;
      });
    } else {
      // Handle regular fields
      setForm(prev => {
        const newForm = { ...prev, [name]: value };
        console.log('Step1 updated form (regular):', newForm);
        return newForm;
      });
    }
  };

  // Fungsi untuk menghitung total data keluarga yang valid
  const getValidFamilyCount = () => {
    const familyData = form.familyData || [];
    const siblings = form.siblings || [];
    const children = form.children || [];
    let validCount = 0;
    
    console.log('Family validation check:', { familyData, siblings, children });
    
    // Hitung data keluarga inti yang valid (minimal ada usia)
    familyData.forEach((member, index) => {
      if (member && member.age && member.age.toString().trim() !== '') {
        validCount++;
        console.log(`Family member ${index} valid:`, member);
      }
    });
    
    // Hitung data saudara yang valid
    siblings.forEach((member, index) => {
      if (member && member.age && member.age.toString().trim() !== '') {
        validCount++;
        console.log(`Sibling ${index} valid:`, member);
      }
    });
    
    // Hitung data anak yang valid
    children.forEach((member, index) => {
      if (member && member.age && member.age.toString().trim() !== '') {
        validCount++;
        console.log(`Child ${index} valid:`, member);
      }
    });
    
    console.log('Total valid family count:', validCount);
    return validCount;
  };

  // Fungsi validasi minimal 3 data keluarga
  const validateFamilyData = () => {
    return getValidFamilyCount() >= 3;
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', my: 4, p: 2 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          backgroundColor: '#ffffff', 
          mb: 3,
          border: '2px solid #1976d2',
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(25, 118, 210, 0.15)'
        }}
      >
        <Grid container spacing={3}>
          {/* Header Section */}
          <Grid item xs={12}>
            <Box 
              sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                mb: 3,
                pb: 2,
                borderBottom: '2px solid #e3f2fd'
              }}
            >
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 'bold', 
                  color: '#1976d2',
                  fontSize: '1.5rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1
                }}
              >
                <span>👤</span>
                Identitas Pribadi
              </Typography>
            </Box>
            <Typography 
              variant="body1" 
              sx={{ 
                color: '#666', 
                mb: 3,
                fontStyle: 'italic',
                fontSize: '0.95rem'
              }}
            >
              Silakan isi data identitas pribadi Anda dengan lengkap dan benar
            </Typography>
          </Grid>
          
          {/* Data Dasar */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>Data Dasar</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Nama Lengkap" 
                    name="fullName" 
                    value={form.fullName || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: John Doe"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Nama Panggilan" 
                    name="nickname" 
                    value={form.nickname || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: John"
                    variant="outlined"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Email" 
                    name="email" 
                    value={form.email || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: john@example.com"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="No. Telepon" 
                    name="phone" 
                    value={form.phone || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: 08123456789"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Tempat Lahir" 
                    name="birthPlace" 
                    value={form.birthPlace || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Jakarta"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    type="date" 
                    label="Tanggal Lahir" 
                    name="birthDate" 
                    value={form.birthDate || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    variant="outlined"
                    required
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <TextField 
                    label="Kewarganegaraan & Suku Bangsa" 
                    name="nationality" 
                    value={form.nationality || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Indonesia - Jawa"
                    variant="outlined"
                    required
                    sx={{
                      minWidth: '300px',
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="religion-label">Agama</InputLabel>
                    <Select 
                      labelId="religion-label" 
                      label="Agama" 
                      name="religion" 
                      value={form.religion || ''} 
                      onChange={handleChange}
                      required
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      {RELIGIONS.map((r) => (
                        <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={8}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="marital-label">Status Pernikahan</InputLabel>
                    <Select 
                      labelId="marital-label" 
                      label="Status Pernikahan" 
                      name="maritalStatus" 
                      value={form.maritalStatus || ''} 
                      onChange={handleChange}
                      required
                      sx={{
                        minWidth: 250,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      {MARITALS.map((m) => (
                        <MenuItem key={m.value} value={m.value}>{m.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="gender-label">Jenis Kelamin</InputLabel>
                    <Select 
                      labelId="gender-label" 
                      label="Jenis Kelamin" 
                      name="gender" 
                      value={form.gender || ''} 
                      onChange={handleChange}
                      required
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      {GENDERS.map((g) => (
                        <MenuItem key={g.value} value={g.value}>{g.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Data Fisik */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>Data Fisik</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="blood-label">Golongan Darah</InputLabel>
                    <Select 
                      labelId="blood-label" 
                      label="Golongan Darah" 
                      name="bloodType" 
                      value={form.bloodType || ''} 
                      onChange={handleChange}
                      sx={{
                        minWidth: 250,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      {BLOODS.map((b) => (
                        <MenuItem key={b} value={b}>{b || '-'}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="colorblind-label">Buta Warna</InputLabel>
                    <Select 
                      labelId="colorblind-label" 
                      label="Buta Warna" 
                      name="colorBlind" 
                      value={form.colorBlind || ''} 
                      onChange={handleChange}
                      sx={{
                        minWidth: 200,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="yes">Ya</MenuItem>
                      <MenuItem value="no">Tidak</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Tinggi Badan (cm)" 
                    name="heightCm" 
                    value={form.heightCm || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: 170"
                    variant="outlined"
                    type="number"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="Berat Badan (kg)" 
                    name="weightKg" 
                    value={form.weightKg || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: 65"
                    variant="outlined"
                    type="number"
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Data Identitas & Alamat */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>Data Identitas & Alamat</Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <TextField 
                    label="No. KTP" 
                    name="ktpNumber" 
                    value={form.ktpNumber || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: 1234567890123456"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth size="medium">
                    <InputLabel id="living-label">Jenis Tempat Tinggal</InputLabel>
                    <Select 
                      labelId="living-label" 
                      label="Jenis Tempat Tinggal" 
                      name="livingArrangement" 
                      value={form.livingArrangement || ''} 
                      onChange={handleChange}
                      required
                      sx={{
                        minWidth: 250,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 2,
                          '&:hover fieldset': {
                            borderColor: '#1976d2',
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#1976d2',
                          },
                        },
                        '& .MuiInputLabel-root': {
                          fontWeight: 500,
                          color: '#555',
                        },
                      }}
                    >
                      {LIVING_ARRANGEMENTS.map((l) => (
                        <MenuItem key={l.value} value={l.value}>{l.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Alamat Sesuai KTP" 
                    name="addressKtp" 
                    value={form.addressKtp || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Jl. Example No. 123, Jakarta"
                    variant="outlined"
                    required
                    multiline
                    rows={2}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    label="Alamat Sekarang" 
                    name="addressCurrent" 
                    value={form.addressCurrent || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Jl. Example No. 456, Jakarta"
                    variant="outlined"
                    required
                    multiline
                    rows={2}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Kontak Darurat */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>Kontak Darurat</Typography>
              <Typography variant="body2" sx={{ color: '#666', mb: 3, fontStyle: 'italic' }}>
                Kontak yang dapat dihubungi jika Anda tidak dapat dihubungi
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField 
                    label="Nama Lengkap" 
                    name="emergencyContactName" 
                    value={form.emergencyContactName || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Jane Doe"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField 
                    label="No. HP" 
                    name="emergencyContactPhone" 
                    value={form.emergencyContactPhone || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: 08123456789"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField 
                    label="Hubungan" 
                    name="emergencyContactRelation" 
                    value={form.emergencyContactRelation || ''} 
                    onChange={handleChange} 
                    fullWidth 
                    size="medium"
                    placeholder="Contoh: Orang Tua, Saudara, Teman"
                    variant="outlined"
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                      '& .MuiInputLabel-root': {
                        fontWeight: 500,
                        color: '#555',
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Data Keluarga */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#495057' }}>Data Keluarga</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body2" sx={{ color: validateFamilyData() ? '#4caf50' : '#f44336', fontWeight: 'bold' }}>
                    {validateFamilyData() ? '✓ Valid' : `⚠ ${Math.max(0, 3 - getValidFamilyCount())} data lagi`}
                  </Typography>
                </Box>
              </Box>
              <Typography variant="body2" sx={{ color: '#666', mb: 3, fontStyle: 'italic' }}>
                Silakan isi data keluarga Anda (minimal 3 data)
              </Typography>
              
              <Box sx={{ mb: 4 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 3, color: '#1976d2' }}>
                  Keluarga Inti
                </Typography>
                
                <FamilyMember 
                  index={0}
                  title="1. Ayah Kandung (Father)"
                  form={form}
                  handleChange={handleChange}
                />
                
                <FamilyMember 
                  index={1}
                  title="2. Ibu Kandung (Mother)"
                  form={form}
                  handleChange={handleChange}
                />
              </Box>
              
              <Box sx={{ mb: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Saudara Kandung
                  </Typography>
                  <Button 
                    onClick={addSibling}
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#1976d2',
                      color: '#1976d2',
                      '&:hover': {
                        borderColor: '#1565c0',
                        backgroundColor: '#e3f2fd',
                      }
                    }}
                  >
                    Tambah Saudara
                  </Button>
                </Box>
                
                {/* Dynamic sibling entries */}
                {form.siblings && form.siblings.map((_, index) => (
                  <FamilyMember 
                    key={index}
                    index={index}
                    title={`Saudara ${index + 1}`}
                    form={form}
                    handleChange={handleChange}
                    onRemove={() => removeSibling(index)}
                    showRemove={true}
                    isSibling={true}
                  />
                ))}
                
                {/* Tampilkan pesan jika belum ada saudara */}
                {(!form.siblings || form.siblings.length === 0) && (
                  <Typography variant="body2" sx={{ color: '#999', fontStyle: 'italic', textAlign: 'center', py: 2 }}>
                    Belum ada data saudara kandung. Klik "Tambah Saudara" untuk menambahkan.
                  </Typography>
                )}
              </Box>
              
              {/* Bagian Keluarga */}
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Keluarga
                  </Typography>
                </Box>
                
                {/* Suami/Istri - Static */}
                <FamilyMember 
                  index={2}
                  title="Suami / Istri (Husband / Wife)"
                  form={form}
                  handleChange={handleChange}
                  showRemove={false}
                />
              </Box>
              
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
                    Anak
                  </Typography>
                  <Button 
                    onClick={addChild}
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{
                      borderColor: '#1976d2',
                      color: '#1976d2',
                      '&:hover': {
                        borderColor: '#1565c0',
                        backgroundColor: '#e3f2fd',
                      }
                    }}
                  >
                    Tambah Anak
                  </Button>
                </Box>
                
                {/* Dynamic children entries */}
                {form.children && form.children.map((_, index) => (
                  <FamilyMember 
                    key={index}
                    index={index}
                    title={`Anak ${index + 1}`}
                    form={form}
                    handleChange={handleChange}
                    onRemove={() => removeChild(index)}
                    showRemove={true}
                    isChild={true}
                  />
                ))}
                
                {/* Tampilkan pesan jika belum ada anak */}
                {(!form.children || form.children.length === 0) && (
                  <Typography variant="body2" sx={{ color: '#999', fontStyle: 'italic', textAlign: 'center', py: 2 }}>
                    Belum ada data anak. Klik "Tambah Anak" untuk menambahkan.
                  </Typography>
                )}
              </Box>
            </Paper>
          </Grid>

          {/* Personal Characteristics Section */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 3, color: '#495057' }}>
                Karakteristik Pribadi
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                    Hobby<span style={{ color: '#f44336', fontSize: '1.2em' }}> </span><span style={{ color: '#666', fontSize: '0.9em', fontWeight: 'normal' }}> (Hobbies)</span>
                  </Typography>
                  <TextField 
                    placeholder="Tuliskan hobi atau kegiatan yang Anda sukai..."
                    value={form.hobby || ''}
                    onChange={(e) => setForm(prev => ({ ...prev, hobby: e.target.value }))}
                    fullWidth 
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={2}
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                    Sifat-sifat positif - minimal 3 hal<span style={{ color: '#f44336', fontSize: '1.2em' }}> </span><span style={{ color: '#666', fontSize: '0.9em', fontWeight: 'normal' }}> (Self positive points - minimum 3 items)</span>
                  </Typography>
                  <TextField 
                    placeholder="Sebutkan minimal 3 sifat positif yang Anda miliki..."
                    value={form.selfPositivePoints || ''}
                    onChange={(e) => setForm(prev => ({ ...prev, selfPositivePoints: e.target.value }))}
                    fullWidth 
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={2}
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
                    Kelemahan – minimal 3 hal<span style={{ color: '#f44336', fontSize: '1.2em' }}> </span><span style={{ color: '#666', fontSize: '0.9em', fontWeight: 'normal' }}> (Self Weakness points – minimum 3 items)</span>
                  </Typography>
                  <TextField 
                    placeholder="Sebutkan minimal 3 kelemahan yang Anda miliki..."
                    value={form.selfWeaknessPoints || ''}
                    onChange={(e) => setForm(prev => ({ ...prev, selfWeaknessPoints: e.target.value }))}
                    fullWidth 
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={2}
                    required
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Innovation Section */}
          <Grid item xs={12}>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#f8f9fa' }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: '#495057' }}>
                Apakah saudara pernah melakukan suatu perubahan / pembaharuan yang cukup menonjol di perusahaan tersebut.
                Perubahan / pembaharuan apa?<span style={{ color: '#f44336', fontSize: '1.2em' }}> </span>
                <br/>
                <span style={{ fontSize: '0.9em', color: '#666', fontWeight: 'normal' }}>(Have you made any changes / innovation which was significant to your former companies.
                If yes please describe what kind of changes / innovation you have made?)</span>
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField 
                    placeholder="Jelaskan perubahan atau inovasi yang telah Anda lakukan..."
                    value={form.innovationDescription || ''}
                    onChange={(e) => setForm(prev => ({ ...prev, innovationDescription: e.target.value }))}
                    fullWidth 
                    size="medium"
                    variant="outlined"
                    multiline
                    rows={4}
                    required
                    sx={{
                      minWidth: 500,
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 2,
                        '&:hover fieldset': {
                          borderColor: '#1976d2',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#1976d2',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default Step1DataPribadi;
